module.exports = __webpack_public_path__ + "img/bhutan-1.bec05389.svg";